import { Injectable, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class HeaderService {

 public  isSocialShareChange = new EventEmitter<boolean>();

  constructor() {}


  public isSocialShare(status: boolean) {
    this.isSocialShareChange.emit(status);
  }
}
